import { render, staticRenderFns } from "./ShenpiBtns.vue?vue&type=template&id=045c7c73"
import script from "./ShenpiBtns.vue?vue&type=script&lang=js"
export * from "./ShenpiBtns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports